import { useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import { YUPValidations, checkRatesEquality } from "./helper";
import _debounce from "lodash/debounce";
import {
  MandatoryStar,
  getDispatch,
  getSnackbarSuccess,
  isLoadingAction,
} from "../../../../Utils/helper";
import Select from "react-select";
import {
  activeInactivePackageAction,
  addPackageCreationAction,
  getAllTestsCreationAction,
  getPackageCreationByIdAction,
  getPreparationForCheckupAction,
} from "../../../../redux/actions/TestPackageCreationAction";
import { useCallback, useEffect, useState } from "react";
import Modal from "react-modal";
import { InputOptionSelect } from "../../../../common/InputOptionSelect";
import { GET_PREPARATION_FOR_CHECKUP } from "../../../../Utils/types";
import { trimInputHandler } from "../TestCreation.js/helper";
import { getSkuSearchTagValues } from "../../TestPackages/Test/helper";
import { getTagListNetworkAction } from "../../../../redux/actions/TestPackageNetworkAction";
import { PackageCategory } from "./PackageCategory";

const AddCreationPage = ({ setShowCreationPage, setIsRowData, isRowData }) => {
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [tests, setTests] = useState([]);
  const [localFacilityCategoryId, setLocalFacilityCategoryId] = useState(0);
  const [isOpenSetting, setIsOpenSetting] = useState(false);
  const [isDeactiveUser, setIsDeactiveUser] = useState(false);
  const [clientPackages, setClientPackages] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isCreatingNew, setIsCreatingNew] = useState(false);
  const [createNewText, setCreateNewText] = useState(null);
  const [header,setHeader] = useState([])
  const [facilityGrp,setFacilityGrp] = useState([header])
  const TestPackageReducer = useSelector((state) => state?.TestPackageReducer);
  const TestPackageCreationReducer = useSelector(
    (state) => state?.TestPackageCreationReducer
  );
  const debounceTestCreation = useCallback(
    _debounce(handleDebounceTestCreation, 500),
    []
  );

  useEffect(()=>{
    let arr = TestPackageCreationReducer?.getFacilityCategoryNetwork.filter((ele,index)=>{
        if(index <=4){
            return ele
        } else {
          return
        }
    })
    
    setHeader(arr)
    setFacilityGrp(arr)
  },[])
  

  useEffect(() => {
    dispatch(
      getAllTestsCreationAction({
        search: "",
        FacilityCategoryId: localFacilityCategoryId,
      })
    );
    dispatch(
      getPreparationForCheckupAction({
        preparationForCheckup: "",
      })
    );
    dispatch(getTagListNetworkAction());
  }, []);

  useEffect(() => {
    if (isRowData !== null) {
      isLoadingAction(true, dispatch);
      const resp = dispatch(
        getPackageCreationByIdAction(isRowData?.facilityId)
      );
      resp.then((res) => {
        const isMRPandAgreedRateSame = checkRatesEquality(
          res?.data?.results?.clientPackages
        );
        isLoadingAction(false, dispatch);
        setData(
          res?.data?.results?.packageTypeId == 1
            ? res?.data?.results
            : {
                ...res?.data?.results,
                isRateSame: isMRPandAgreedRateSame,
                mrpRate: isMRPandAgreedRateSame
                  ? res?.data?.results?.clientPackages?.[0]?.mrpRate
                  : 0,
                agreedRate: isMRPandAgreedRateSame
                  ? res?.data?.results?.clientPackages?.[0]?.agreedRate
                  : 0,
              }
        );
        setClientPackages(res?.data?.results?.clientPackages);
        setTests(res?.data?.results?.tests);
      });
    }
  }, [isRowData]);

  function handleDebounceTestCreation(inputValue, localFacilityCategoryId) {
    dispatch(
      getAllTestsCreationAction({
        search: inputValue,
        FacilityCategoryId: localFacilityCategoryId,
      })
    );
  }

  const clientDetailsChangeHandler = (id, name, value) => {
    let updatedTodos = clientPackages?.map((ele, index) => {
      if (index === id) {
        ele[name] = value;
      }
      return ele;
    });
    setClientPackages(updatedTodos);
  };

  return (
    <div className="right-section" style={{ padding: "20px" }}>
      <div
        className="back-buttondiv"
        onClick={() => {
          setShowCreationPage(false);
        }}
      >
        <i className="fa-solid fa-circle-arrow-left"></i>
        <h6 style={{ cursor: "pointer" }}>Back</h6>
      </div>
      <div className="staff-details-header d-flex justify-content-between align-items-center edit-save-css">
        <div>
          <h4
            className="font-bold text-highlight"
            style={{ letterSpacing: "1px" }}
          >
            {isRowData !== null ? "Edit Package" : "Create Package"}
          </h4>
        </div>
      </div>
      <Formik
        enableReinitialize={true}
        initialValues={{ ...data }}
        onSubmit={async (values) => {
          const temp = {
            ...values,
            packageId: isRowData ? isRowData?.facilityId : 0,
            clientPackages: values?.packageTypeId == 2 ? clientPackages : [],
            tests: tests,
            packageTypeId: +values?.packageTypeId,
            mrpRate:
              !values?.isRateSame && values?.packageTypeId == 2
                ? 0
                : +values?.mrpRate,
            agreedRate:
              !values?.isRateSame && values?.packageTypeId == 2
                ? 0
                : +values?.agreedRate,
            ageFrom: +values?.ageFrom,
            ageTo: +values?.ageTo,
          };
          const isMRPGreaterThanAgreedRate = clientPackages.every(
            (item) =>Number(item.mrpRate )>= Number(item.agreedRate)
            
          );
          if (!isMRPGreaterThanAgreedRate) {
            getSnackbarSuccess(
              "info",
              "APP MRP should be greater than APP Customer Rate",
              dispatch
            );
          } else if (!tests?.length) {
            getSnackbarSuccess("info", "please select test", dispatch);
          } else if (!values?.diseaseTag?.length) {
            getSnackbarSuccess("info", "please select disease tags", dispatch);
          } else {
            isLoadingAction(true, dispatch);
            const resp = dispatch(addPackageCreationAction(temp));
            resp.then((res) => {
              if (res?.data?.status === true) {
                getSnackbarSuccess("success", res?.data?.message, dispatch);
                isLoadingAction(false, dispatch);
                setShowCreationPage(false);
                setIsRowData(null);
              } else {
                getSnackbarSuccess("error", res?.data?.message, dispatch);
                isLoadingAction(false, dispatch);
              }
            });
          }
        }}
        validationSchema={YUPValidations}
      >
        {(props) => {
          const { values, errors, handleChange, handleSubmit, setFieldValue } =
            props;
          return (
            <form className="form-admin" onSubmit={handleSubmit}>
              <div className="card staff-details-section mt20">
                <div className="card-body" style={{ padding: "12px" }}>
                  <div className="custom-container">
                    <div className="row">
                      <div className="custom-column col-lg-4 col-md-4">
                        <div className="heading">
                          Package Type
                          <MandatoryStar /> :
                        </div>
                        <div className="w-55">
                          <select
                            name="packageTypeId"
                            className="white-form-select"
                            value={values?.packageTypeId}
                            onChange={handleChange}
                            disabled={isRowData}
                          >
                            <option value="">Select</option>
                            <option value={1}>
                              Standard (Applicable on All CBU Clients)
                            </option>
                            <option value={2}>Client Specific</option>
                          </select>
                          <div className="errorInputMessage">
                            {errors?.packageTypeId}
                          </div>
                        </div>
                      </div>
                      {values?.packageTypeId == 2 && (
                        <div className="custom-column col-lg-8 col-md-8">
                          <div className="heading">
                            Client Name
                            <MandatoryStar /> :
                          </div>
                          <div style={{ width: "78%" }}>
                            <Select
                              closeMenuOnSelect={false}
                              className="basic-multi-select"
                              style={{ width: "100%" }}
                              classNamePrefix="select"
                              placeholder="Select Client"
                              name="colors"
                              isClearable={true}
                              isMulti
                              options={TestPackageCreationReducer?.getClientListNetwork?.map(
                                (ele) => {
                                  return {
                                    clientId: ele?.clientId,
                                    clientName: ele?.clientName,
                                  };
                                }
                              )}
                              getOptionLabel={(option) => option.clientName}
                              getOptionValue={(option) => option.clientId}
                              onChange={(e, actionMeta) => {
                                
                                if (actionMeta.action === "select-option") {
                                  setClientPackages([
                                    ...clientPackages,
                                    actionMeta?.option,
                                  ]);
                                  if( data?.packageTypeId == 2){
                                    let data =  e?.map((item) => ({
                                      ...item,
                                      mrpRate: clientPackages[0]?.mrpRate,
                                      agreedRate:clientPackages[0]?.agreedRate
  
                                    }))
                                    setClientPackages(data)
                                  }
                                } else if (
                                  actionMeta.action === "remove-value"
                                ) {
                                  setClientPackages(
                                    clientPackages.filter(
                                      (item) =>
                                        item.clientId !==
                                        actionMeta?.removedValue?.clientId
                                    )
                                  );
                                  if( data?.packageTypeId == 2){
                                    let data =  e?.map((item) => ({
                                      ...item,
                                      mrpRate: clientPackages[0]?.mrpRate,
                                      agreedRate:clientPackages[0]?.agreedRate
  
                                    }))
                                    setClientPackages(data)
                                  }
                                } else if (actionMeta.action === "clear") {
                                  setClientPackages([]);
                                }
                              }}
                              value={clientPackages?.map((ele) => {
                                return {
                                  clientId: ele?.clientId,
                                  clientName: ele?.clientName,
                                };
                              })}
                            />
                            <div className="errorInputMessage">
                              {errors?.packageTypeId}
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="custom-column col-lg-4 col-md-4">
                        <div className="heading">
                          Home Visit
                          <MandatoryStar /> :
                        </div>
                        <div className="w-55">
                          <select
                            name="isHomeVisitAllowed"
                            className="white-form-select"
                            value={values?.isHomeVisitAllowed}
                            onChange={(e) => {
                              setFieldValue(
                                "isHomeVisitAllowed",
                                e.target.value === "true"
                                  ? true
                                  : e.target.value === "false"
                                  ? false
                                  : e.target.value
                              );
                            }}
                          >
                            <option value="">Select</option>
                            <option value={true}>Yes</option>
                            <option value={false}>No</option>
                          </select>
                          <div className="errorInputMessage">
                            {errors?.isHomeVisitAllowed}
                          </div>
                        </div>
                      </div>
                      <div className="custom-column col-lg-4 col-md-4">
                        <div className="heading">
                          Package Name
                          <MandatoryStar /> :
                        </div>
                        <div className="w-55">
                          <input
                            name="packageName"
                            type="text"
                            placeholder="Package Name"
                            className="white-form-select"
                            value={values?.packageName}
                            onChange={handleChange}
                          />
                          <div className="errorInputMessage">
                            {errors?.packageName}
                          </div>
                        </div>
                      </div>
                      <div className="custom-column col-lg-4 col-md-4">
                        <div className="heading">
                          APP Display Name
                          <MandatoryStar /> :
                        </div>
                        <div className="w-55">
                          <input
                            name="packageDisplayName"
                            type="text"
                            placeholder="APP Display Name"
                            className="white-form-select"
                            value={values?.packageDisplayName}
                            onChange={handleChange}
                          />
                          <div className="errorInputMessage">
                            {errors?.packageDisplayName}
                          </div>
                        </div>
                      </div>
                      <div className="custom-column col-lg-4 col-md-4">
                        <div className="heading">
                          Fasting
                          <MandatoryStar /> :
                        </div>
                        <div className="w-55">
                          <select
                            name="isFastingRequired"
                            className="white-form-select"
                            value={values?.isFastingRequired}
                            onChange={(e) => {
                              setFieldValue(
                                "isFastingRequired",
                                e.target.value === "true"
                                  ? true
                                  : e.target.value === "false"
                                  ? false
                                  : e.target.value
                              );
                            }}
                          >
                            <option value="">Select</option>
                            <option value={true}>Yes</option>
                            <option value={false}>No</option>
                          </select>
                          <div className="errorInputMessage">
                            {errors?.isFastingRequired}
                          </div>
                        </div>
                      </div>
                      <div className="custom-column col-lg-4 col-md-4">
                        <div className="heading">
                          Minimum Age
                          <MandatoryStar /> :
                        </div>
                        <div className="w-55">
                          <input
                            type="number"
                            onKeyDown={(e) => {
                              if (
                                e.key === " " ||
                                e.key === "-" ||
                                e.key === "+"
                              ) {
                                e.preventDefault(); // Prevent entering a space, minus sign, or plus sign
                              }
                            }}
                            name="ageFrom"
                            placeholder="Minimum Age"
                            className="white-form-select"
                            value={values?.ageFrom}
                            onChange={handleChange}
                          />
                          <div className="errorInputMessage">
                            {errors?.ageFrom}
                          </div>
                        </div>
                      </div>
                      <div className="custom-column col-lg-4 col-md-4">
                        <div className="heading">
                          Maximum Age
                          <MandatoryStar /> :
                        </div>
                        <div className="w-55">
                          <input
                            type="number"
                            onKeyDown={(e) => {
                              if (
                                e.key === " " ||
                                e.key === "-" ||
                                e.key === "+"
                              ) {
                                e.preventDefault(); // Prevent entering a space, minus sign, or plus sign
                              }
                            }}
                            name="ageTo"
                            placeholder="Maximum Age"
                            className="white-form-select"
                            value={values?.ageTo}
                            onChange={handleChange}
                          />
                          <div className="errorInputMessage">
                            {errors?.ageTo}
                          </div>
                        </div>
                      </div>
                      <div className="custom-column col-lg-4 col-md-4">
                        <div className="heading">
                          Gender
                          <MandatoryStar /> :
                        </div>
                        <div className="w-55">
                          <select
                            name="gender"
                            className="white-form-select"
                            value={values?.gender}
                            onChange={handleChange}
                          >
                            <option value="">Select</option>
                            <option value="M">Male</option>
                            <option value="F">Female</option>
                            <option value="B">Both</option>
                          </select>
                          <div className="errorInputMessage">
                            {errors?.gender}
                          </div>
                        </div>
                      </div>
                      <div className="custom-column col-lg-4 col-md-4">
                        <div className="heading">
                          Report By
                          <MandatoryStar /> :
                        </div>
                        <div className="w-55">
                          <select
                            name="finalReporting"
                            className="white-form-select"
                            value={values?.finalReporting}
                            onChange={handleChange}
                          >
                            <option value="">Select</option>
                            <option value="Next Day">Next Day</option>
                            <option value="Same Day">Same Day</option>
                            <option value="1 Day(s)*">1 Day(s)*</option>
                            <option value="2 Day(s)*">2 Day(s)*</option>
                            <option value="3 Day(s)*">3 Day(s)*</option>
                            <option value="4 Day(s)*">4 Day(s)*</option>
                            <option value="5 Day(s)*">5 Day(s)*</option>
                            <option value="6 Day(s)*">6 Day(s)*</option>
                          </select>
                          <div className="errorInputMessage">
                            {errors?.finalReporting}
                          </div>
                        </div>
                      </div>
                      <div className="custom-column col-lg-4 col-md-4">
                        <div className="heading">Description :</div>
                        <div className="w-55">
                          <input
                            name="description"
                            type="text"
                            placeholder="Description"
                            className="white-form-select"
                            value={values?.description}
                            onChange={handleChange}
                          />
                          <div className="errorInputMessage">
                            {errors?.description}
                          </div>
                        </div>
                      </div>
                      <div className="custom-column col-lg-4 col-md-4">
                        <div className="heading">Preparation :</div>
                        <div className="w-55">
                          <Select
                            className="basic-multi-select"
                            style={{ width: "100%" }}
                            classNamePrefix="select"
                            placeholder="Select..."
                            name="colors"
                            value={
                              values?.preparationForCheckup
                                ? {
                                    value: values?.preparationForCheckup,
                                    label: values?.preparationForCheckup,
                                  }
                                : null
                            }
                            options={TestPackageCreationReducer?.getPreparationForCheckup?.map(
                              (ele) => {
                                return {
                                  value: ele?.preparationForCheckup,
                                  label: ele?.preparationForCheckup,
                                };
                              }
                            )}
                            onChange={(e) => {
                              if (e?.value === "Create New +") {
                                setIsCreatingNew(true);
                              } else {
                                setFieldValue(
                                  "preparationForCheckup",
                                  e?.value
                                );
                              }
                            }}
                          />
                        </div>
                      </div>
                      <Modal
                        isOpen={isCreatingNew}
                        className="modal-confirmation-popup"
                        overlayClassName="overlay-confirmation-popup network-z-index"
                        ariaHideApp={false}
                      >
                        <div
                          className="modal-body modal-body-active-popup popup-text"
                          style={{ paddingBottom: "0px" }}
                        >
                          <textarea
                            className="preparation-textarea"
                            placeholder="Enter preparation for checkup here..."
                            onChange={(e) =>
                              trimInputHandler(e, setCreateNewText)
                            }
                          />
                        </div>
                        <div
                          className="modal-footer modal-footer-active-popup"
                          style={{ marginTop: "0px" }}
                        >
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => {
                              getDispatch(
                                GET_PREPARATION_FOR_CHECKUP,
                                [
                                  ...TestPackageCreationReducer?.getPreparationForCheckup,
                                  { preparationForCheckup: createNewText },
                                ],
                                dispatch
                              );
                              setFieldValue(
                                "preparationForCheckup",
                                createNewText
                              );
                              setCreateNewText(null);
                              setIsCreatingNew(false);
                            }}
                            disabled={
                              createNewText?.length === 0 ||
                              createNewText === null
                            }
                            style={{ width: "90px" }}
                          >
                            Save
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary btn-logout-no"
                            onClick={() => {
                              setCreateNewText(null);
                              setIsCreatingNew(false);
                            }}
                          >
                            Cancel
                          </button>
                        </div>
                      </Modal>
                      {values?.packageTypeId == 2 && (
                        <div className="custom-column col-lg-4 col-md-4">
                          <div className="heading">Rate Same for all :</div>
                          <div className="w-55">
                            <select
                              name="isRateSame"
                              className="white-form-select"
                              value={values?.isRateSame}
                              onChange={(e) => {
                                setFieldValue(
                                  "isRateSame",
                                  e.target.value === "true"
                                    ? true
                                    : e.target.value === "false"
                                    ? false
                                    : e.target.value
                                );
                              }}
                            >
                              <option value="">Select</option>
                              <option value={true}>Yes</option>
                              <option value={false}>No</option>
                            </select>
                          </div>
                        </div>
                      )}
                      {(values?.packageTypeId == 1 ||
                        (values?.packageTypeId == 2 && values?.isRateSame)) && (
                        <>
                          <div className="custom-column col-lg-4 col-md-4">
                            <div className="heading">
                              APP MRP
                              <MandatoryStar /> :
                            </div>
                            <div className="w-55">
                              <input
                                name="mrpRate"
                                type="number"
                                placeholder="APP Mrp Rate"
                                className="white-form-select"
                                value={values?.mrpRate}
                                onKeyDown={(e) => {
                                  if (
                                    e.key === " " ||
                                    e.key === "-" ||
                                    e.key === "+"
                                  ) {
                                    e.preventDefault(); // Prevent entering a space, minus sign, or plus sign
                                  }
                                }}
                                onChange={(e) => {
                                  setFieldValue("mrpRate", e.target.value);
                                  values?.packageTypeId == 2 &&
                                    setClientPackages(
                                      clientPackages?.map((item) => ({
                                        ...item,
                                        mrpRate: e.target.value,
                                      }))
                                    );
                                }}
                              />
                              <div className="errorInputMessage">
                                {errors?.mrpRate}
                              </div>
                            </div>
                          </div>
                          <div className="custom-column col-lg-4 col-md-4">
                            <div className="heading">
                              APP Customer Rate
                              <MandatoryStar /> :
                            </div>
                            <div className="w-55">
                              <input
                                name="agreedRate"
                                type="number"
                                placeholder="APP Customer Rate"
                                className="white-form-select"
                                value={values?.agreedRate}
                                onKeyDown={(e) => {
                                  if (
                                    e.key === " " ||
                                    e.key === "-" ||
                                    e.key === "+"
                                  ) {
                                    e.preventDefault(); // Prevent entering a space, minus sign, or plus sign
                                  }
                                }}
                                onChange={(e) => {
                                  setFieldValue("agreedRate", e.target.value);
                                  values?.packageTypeId == 2 &&
                                    setClientPackages(
                                      clientPackages?.map((item) => ({
                                        ...item,
                                        agreedRate: e.target.value,
                                      }))
                                    );
                                }}
                              />
                              <div className="errorInputMessage">
                                {errors?.agreedRate}
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                      <div className="custom-column col-lg-8 col-md-8">
                        <div className="heading">
                          Disease Tags
                          <MandatoryStar /> :
                        </div>
                        <div style={{ width: "78%" }}>
                          <Select
                            className="basic-multi-select background_select bgselect-white"
                            classNamePrefix="select"
                            placeholder="Search Disease Tags"
                            name="colors"
                            isMulti
                            closeMenuOnSelect={false}
                            options={TestPackageReducer?.getTagListNetworkDetails?.map(
                              (ele) => {
                                return {
                                  value: ele?.tagName,
                                  label: ele?.tagName,
                                };
                              }
                            )}
                            onChange={(e) => {
                              setFieldValue(
                                "diseaseTag",
                                e?.map((ele) => ele.value)?.toString()
                              );
                            }}
                            value={getSkuSearchTagValues(
                              TestPackageReducer?.getTagListNetworkDetails,
                              values?.diseaseTag
                            )}
                          />
                        </div>
                      </div>
                    </div>
                    {values?.packageTypeId == 2 && (
                      <div className="staff-table creation-table">
                        <div className="table-responsive">
                          <table className="table">
                            <thead>
                              <tr>
                                <th className="w60">Client Name</th>
                                <th>APP MRP</th>
                                <th>APP Customer Rate</th>
                              </tr>
                            </thead>
                            <tbody>
                              {clientPackages?.map((ele, index) => {
                                const isInvalid =
                                  +ele.mrpRate < +ele.agreedRate; // Check if MRP is less than or equal to Customer Rate
                                return (
                                  <tr key={index}>
                                    <td className="text-center">
                                      {ele.clientName}
                                    </td>
                                    <td>
                                      <input
                                        type="number"
                                        className={`__inputs font-medium text-black ${
                                          isInvalid ? "invalid" : ""
                                        }`}
                                        style={{ width: "100%" }}
                                        placeholder="Enter here..."
                                        value={ele?.mrpRate}
                                        onKeyDown={(e) => {
                                          if (
                                            e.key === " " ||
                                            e.key === "-" ||
                                            e.key === "+"
                                          ) {
                                            e.preventDefault(); // Prevent entering a space, minus sign, or plus sign
                                          }
                                        }}
                                        onChange={(e) =>
                                          clientDetailsChangeHandler(
                                            index,
                                            "mrpRate",
                                            e.target.value
                                          )
                                        }
                                        disabled={values?.isRateSame}
                                        required
                                      />
                                      {isInvalid && (
                                        <span className="errorInputMessage">
                                          APP MRP should be greater than APP
                                          Customer Rate
                                        </span>
                                      )}
                                    </td>
                                    <td>
                                      <input
                                        type="number"
                                        className={`__inputs font-medium text-black ${
                                          isInvalid ? "invalid" : ""
                                        }`}
                                        onKeyDown={(e) => {
                                          if (
                                            e.key === " " ||
                                            e.key === "-" ||
                                            e.key === "+"
                                          ) {
                                            e.preventDefault(); // Prevent entering a space, minus sign, or plus sign
                                          }
                                        }}
                                        style={{ width: "100%" }}
                                        placeholder="Enter here..."
                                        value={ele?.agreedRate}
                                        onChange={(e) =>
                                          clientDetailsChangeHandler(
                                            index,
                                            "agreedRate",
                                            e.target.value
                                          )
                                        }
                                        disabled={values?.isRateSame}
                                        required
                                      />
                                      {isInvalid && (
                                        <span className="errorInputMessage">
                                          APP Customer Rate should be less than
                                          APP MRP
                                        </span>
                                      )}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="card staff-details-section mt20">
                <div className="card-body">
                  <div className="creation-navbar">
                    {facilityGrp?.map(
                      (ele, index) => {
                        return (
                          <button
                            key={index}
                            type="button"
                            className={`navbar-btn ${
                              index === activeIndex ? "navbar-active" : ""
                            }`}
                            onClick={() => {
                              setLocalFacilityCategoryId(
                                ele?.facilityCategoryId
                              );
                              dispatch(
                                getAllTestsCreationAction({
                                  search: "",
                                  FacilityCategoryId: ele?.facilityCategoryId,
                                })
                              );
                              setActiveIndex(index);
                            }}
                          >
                            {ele?.facilityCategory}
                            <p
                              className={`${
                                !tests?.length
                                  ? ""
                                  : index === activeIndex
                                  ? "navbar-value"
                                  : "hide-navbar-value"
                              }`}
                            >
                              {tests?.length ? ele?.facilityCategory === "Overall" ? tests?.length
                                  : tests?.filter(
                                      (item) =>
                                        ele?.facilityCategory?.split(" ").join("").toUpperCase() ===
                                        item.facilityCategory?.split(" ").join("").toUpperCase()
                                    )?.length
                                : null}
                            </p>
                          </button>
                        );
                      }
                    )}
                    <button
                    className="search__btn ascDescBtn p-2"
                    data-bs-toggle="modal"
                    id="ascDescPayableBtn"
                    style={{fontSize:"20px"}}
                    onClick={()=>{
                      setIsOpenSetting(true)
                    }}
                    type="button"
                  >
                    <span>Other Services</span>&nbsp;
                    &nbsp;<i
                      class="fa-solid fa-gear"
                      style={{ fontSize: "20px" }}
                    ></i>
                  </button>
                  </div>
                  <div className="creation-select-container">
                    <div className="subcontainer1">
                      <Select
                        placeholder="Search SKU"
                        className="basic-multi-select"
                        hideSelectedOptions={false}
                        style={{ width: "100%" }}
                        classNamePrefix="select"
                        name="colors"
                        isMulti
                        options={TestPackageCreationReducer?.getAllTestCategoryNetwork?.map(
                          (ele) => {
                            return {
                              testId: ele?.facilityId,
                              testName: ele?.facilityName,
                              facilityCategory: ele?.facilityCategory,
                            };
                          }
                        )}
                        getOptionValue={(option) => option.testId}
                        getOptionLabel={(option) => option.testName}
                        onInputChange={(e) => {
                          if (e !== "") {
                            debounceTestCreation(e, localFacilityCategoryId);
                          }
                        }}
                        closeMenuOnSelect={false}
                        onChange={(e, actionMeta) => {
                          if (actionMeta.action === "select-option") {
                            setTests([...tests, actionMeta?.option]);
                          } else if (actionMeta.action === "deselect-option") {
                            setTests(
                              tests.filter(
                                (item) =>
                                  item.testId !== actionMeta?.option?.testId
                              )
                            );
                          } else if (actionMeta.action === "clear") {
                            setTests([]);
                          }
                        }}
                        value={tests
                          ?.filter((item) => {
                            return TestPackageCreationReducer?.getAllTestCategoryNetwork.some(
                              (removeItem) =>
                                removeItem.facilityId === item.testId
                            );
                          })
                          ?.map((ele) => {
                            return {
                              testId: ele?.testId,
                              testName: ele?.testName,
                            };
                          })}
                        components={{
                          Option: InputOptionSelect,
                        }}
                      />
                    </div>
                    <div className="subcontainer2">
                      <div className="wrap">
                        {tests
                          ?.filter((item) => {
                            return TestPackageCreationReducer?.getAllTestCategoryNetwork.some(
                              (removeItem) =>
                                removeItem.facilityId === item.testId
                            );
                          })
                          ?.map((ele) => {
                            return (
                              <div className="showdetail-box">
                                {ele?.testName}
                                <i
                                  className="fa fa-close"
                                  onClick={() =>
                                    setTests(
                                      tests.filter(
                                        (id) => id.testId !== ele?.testId
                                      )
                                    )
                                  }
                                ></i>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                    <div className="subcontainer3">
                      <button className="btn search__btn" type="submit">
                        {isRowData !== null
                          ? "Update Package"
                          : "Create Package"}
                      </button>
                      <button
                        className="btn cancel__btn"
                        type="button"
                        onClick={() => {
                          setShowCreationPage(false);
                        }}
                      >
                        Cancel
                      </button>
                      {isRowData !== null && (
                        <button
                          type="button"
                          className={`${
                            data?.isActive ? "deactive-button" : "active-button"
                          }`}
                          onClick={() => {
                            setIsDeactiveUser(true);
                          }}
                        >
                          {data?.isActive
                            ? "Deactivate Package"
                            : "Activate Package"}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </form>
          );
        }}
      </Formik>
      <Modal
        isOpen={isDeactiveUser}
        className="modal-confirmation-popup"
        overlayClassName="overlay-confirmation-popup  network-z-index"
        ariaHideApp={false}
      >
        <>
          <div className="modal-body modal-body-active-popup popup-text">
            Are you sure you want to
            {data?.isActive ? " Deactive" : " Active"} this package ?
          </div>
          <div className="modal-footer modal-footer-active-popup">
            <button
              type="button"
              className="btn btn-primary"
              style={{ width: "90px" }}
              onClick={async () => {
                await setIsDeactiveUser(false);
                await dispatch(
                  activeInactivePackageAction(
                    data?.packageId,
                    data?.isActive == true ? false : true
                  )
                );
                setIsDeactiveUser(false);
                setShowCreationPage(false);
                setIsRowData(null);
              }}
            >
              Yes
            </button>
            <button
              type="button"
              className="btn btn-primary btn-logout-no"
              onClick={() => {
                setIsDeactiveUser(false);
              }}
            >
              No
            </button>
          </div>
        </>
      </Modal>
      <Modal
            isOpen={isOpenSetting}
            style={{maxWidth:"35%"}}
            className=" modal-add-user-popup modal-upload-excel-popup payOutAddHeader"
            overlayClassName="overlay-history-popup network-z-index"
            ariaHideApp={false}
          >
            <PackageCategory
            setIsOpenSetting={setIsOpenSetting}
              header={header}
              setHeader={setHeader}
              setFacilityGrp={setFacilityGrp}
              // searchFilter={searchFilter}
            />
          </Modal>
    </div>
  );
};

export default AddCreationPage;
